<template>
  <div>
    <div :class="isqpisboot ? 'wbobye zhadminadd' : 'zhadminadd'" id="ipqcprintTest">
      <div style="text-align: right;z-index: 2;">
        <a :href="form.Flowurl" target="_blank" style="padding-right: 10px;">
          <el-button size="small" type="warning" v-if="form && form.Flownumbers">
            {{ form.Flownumbers }}
          </el-button>
        </a>
        <el-button size="small" type="warning" style="text-align: right;" @click="updateValues"
          v-if="(form.State == 3 || form.State == 1) && ($store.state.Login.Username == form.Examination || $store.state.Login.Jurisdiction == 0) && (form.Date >= '2024-09-26' && form.Date <= '2025-02-06')">随机生成</el-button>
        <el-button size="small" style="text-align: right;" type="primary" v-if="!isdisabled && $store.state.Login.Jurisdiction == 0" @click.stop="openScanOld">{{ $t('All.扫描') }}</el-button>
        <el-button size="small" style="text-align: right;" type="primary" v-if="!isdisabled || $store.state.Login.Jurisdiction == 0" @click.stop="openScanNew">{{ $t('All.扫描新版') }}</el-button>
        <el-button size="small" style="text-align: right;" type="primary" @click="isqpisboot = !isqpisboot">{{ isqpisboot ? $t('All.取消全屏') : $t('All.全屏')}}</el-button>
        <el-button size="small" style="text-align: right;" type="primary" @click.stop="handlePrint">{{ $t('All.打印') }}</el-button>
        <el-button ref="ipqcPrintTrigger" size="small" type="primary" style="text-align: right;" v-print="'#ipqcprintTest'">{{ $t('All.打印') }}</el-button>
        <el-button size="small" style="text-align: right;"
          v-if="form.State == 0 && $store.state.Login.Jurisdiction < 6 || $store.state.Login.Jurisdiction == 0"
          type="warning" @click="qianhe = true">{{ this.$t('All.签核') }}</el-button>
        <el-button size="small" style="text-align: right;"
          v-if="(form.State == 1 || form.State == 3) && $store.state.Login.Username == form.Examination" type="primary"
          @click="songceng()">{{ this.$t('system.songceng') }}</el-button>
        <el-button size="small" style="text-align: right;"
          v-if="(form.State == 3 || form.State == 1) && ($store.state.Login.Username == form.Examination || $store.state.Login.Jurisdiction == 0)"
          type="primary" @click="UserDataZanCun()">{{ this.$t('system.zancun') }}</el-button>
        <el-button size="small" style="text-align: right;"
          v-if="(($store.state.Login.Username == form.Examination || $store.state.Login.Jurisdiction == 0) && (form.State == 1 || form.State == 3)) || $store.state.Login.Jurisdiction == 0"
          type="danger" @click="handledelipqc()">{{ this.$t('system.zuofei') }}</el-button>
        <el-button size="small" type="primary" v-if="!isdisabled"
          @click="dialogVisible = true">{{ this.$t('system.fjian') }}</el-button>
        <el-button size="small" type="primary" v-if="isdisabled"
          @click="dialogVisible = true">{{ this.$t('system.chakanfj') }}</el-button>
        <el-button size="small" style="text-align: right;"
          v-if="($store.state.Login.Username == form.Examination || $store.state.Login.Jurisdiction == 0) && (form.State == 1 || form.State == 3) && isdisabled"
          type="success" @click="isdisabled = false">{{ this.$t('system.unlock') }}</el-button>
        <el-button size="small" style="text-align: right;"
          v-if="($store.state.Login.Username == form.Examination || $store.state.Login.Jurisdiction == 0) && (form.State == 1 || form.State == 3) && !isdisabled"
          type="primary" @click="isdisabled = true">{{ this.$t('system.lock') }}</el-button>
      </div>
      <!-- <div style="height: calc(100% - 32px); overflow: auto;"> -->
        <h2 style="text-align: center;">{{ this.$t('system.company') }}</h2>
        <h3 style="text-align: center;">{{ $t('All.生产巡检报表') }}</h3>
        <h4 style="text-align: center;">{{ this.$t('system.systemid') }}：{{ form.Numbers }}</h4>
        <h4 style="text-align: center;">{{ $t('All.录入人') }}：{{ form.Entered }}</h4>
        <div style="text-align: center;">
          <span style="text-align: center;font-size: 28px;color: red;">{{ State(form.State) }}</span>
        </div>
        <h3 style="text-align: right;padding-right: 10px; ">{{ this.$t('system.InspectionDate') }}：{{ form.Timsdate }}</h3>
        <h5 style="text-align: right;padding-right: 10px; ">{{ $t('All.料号') }}：{{ form.Item_no }}</h5>
        <div style=" padding: 10px; text-align: center; line-height: 2vw;">
          <table border="1" style="width:100%; border-bottom: none;table-layout: fixed; word-break: break-all; word-wrap: break-word;" align="center" cellpadding="10" cellspacing="0">
            <tr>
              <td colspan="2" class="tdd">{{ $t('All.班别') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.制令单号') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.客户') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.品名') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.测试机') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.XRF送测编号') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.ICP送测编号') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.首件判定') }}</td>
            </tr>
            <tr>
              <td v-show="isdisabled" colspan="2" class="tdd"><el-input :disabled='isdisabled'
                  v-model="form.Class"></el-input></td>
              <td v-show="!isdisabled" colspan="2" class="tdd">
                <el-select v-model="form.Class" allow-create filterable :placeholder="this.$t('FQC.请选择')">
                  <el-option v-for="i in $PublicJs.Banbi" :key="i.value" :label="i.label" :value="i.value">
                  </el-option>
                </el-select>
              </td>
              <td colspan="2" class="tdd"><el-input :disabled='isdisabled' v-model="form.Order_no"></el-input></td>
              <td colspan="2" class="tdd"><el-input :disabled='isdisabled' v-model="form.Customer"></el-input></td>
              <td colspan="2" class="tdd"><el-input :disabled='isdisabled' v-model="form.Product_name"></el-input></td>
              <td colspan="2" class="tdd"><el-input :disabled='isdisabled' v-model="form.Test_machine"></el-input></td>
              <td colspan="2" class="tdd"><el-input :disabled='isdisabled' v-model="form.Xrfnumber"></el-input></td>
              <td colspan="2" class="tdd"><el-input :disabled='isdisabled' v-model="form.Icpnumber"></el-input></td>
              <td colspan="2" class="tdd"><el-input :disabled='isdisabled' v-model="form.First_article"></el-input></td>
            </tr>
            <tr>
              <td colspan="2" class="tdd">LOT NO.</td>
              <td colspan="2" class="tdd">{{ $t('All.SOP编号') }}</td>
              <td colspan="2" class="tdd">{{ $t('FQC.外观') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.颜色') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.色样号') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.图面编号') }}</td>
              <td colspan="2" class="tdd">{{ $t('FQC.版本') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.装箱数量') }}</td>
            </tr>
            <tr>
              <td colspan="2" class="tdd"><el-input :disabled='isdisabled' v-model="form.Lot_no"></el-input></td>
              <td colspan="2" class="tdd">
                <el-tooltip effect="dark" :content="form.Sopnumber" placement="top-start">
                  <div
                    style="overflow: hidden;white-space: nowrap;cursor: default;text-overflow: ellipsis;color: #006bda;">
                    <span @click="fileopen(form.Sopnumberurl)">{{ form.Sopnumber }}</span>
                  </div>
                </el-tooltip>
              </td>
              <td v-show="isdisabled" colspan="2" class="tdd"><el-input :disabled='isdisabled'
                  v-model="form.Appearance"></el-input></td>
              <td v-show="!isdisabled" colspan="2" class="tdd">
                <el-select v-model="form.Appearance" :placeholder="$t('All.请判定')">
                  <el-option label="Pass" value="Pass"></el-option>
                  <el-option label="Fail" value="Fail"></el-option>
                </el-select>
              </td>
              <td v-show="isdisabled" colspan="2" class="tdd"><el-input :disabled='isdisabled'
                  v-model="form.Colour"></el-input></td>
              <td v-show="!isdisabled" colspan="2" class="tdd">
                <el-select v-model="form.Colour" allow-create filterable :placeholder="$t('All.请选择')">
                  <el-option :label="$t('All.黑')" :value="$t('All.黑')"></el-option>
                  <el-option :label="$t('All.白')" :value="$t('All.白')"></el-option>
                  <el-option :label="$t('All.橙')" :value="$t('All.橙')"></el-option>
                  <el-option :label="$t('All.黄')" :value="$t('All.黄')"></el-option>
                  <el-option :label="$t('All.绿')" :value="$t('All.绿')"></el-option>
                  <el-option :label="$t('All.青')" :value="$t('All.青')"></el-option>
                  <el-option :label="$t('All.蓝')" :value="$t('All.蓝')"></el-option>
                  <el-option :label="$t('All.紫')" :value="$t('All.紫')"></el-option>
                </el-select>
              </td>
              <td colspan="2" class="tdd"><el-input :disabled='isdisabled' v-model="form.Color_sample_no"></el-input></td>
              <td colspan="2" class="tdd">
                <el-tooltip effect="dark" :content="form.Drawing_no" placement="top-start">
                  <div
                    style="overflow: hidden;white-space: nowrap;cursor: default;text-overflow: ellipsis;color: #006bda;">
                    <span @click="fileopen(form.Drawing_nourl)">{{ form.Drawing_no }}</span>
                  </div>
                </el-tooltip>
              </td>
              <td colspan="2" class="tdd"><el-input :disabled='isdisabled' v-model="form.Edition"></el-input></td>
              <td colspan="2" class="tdd"><el-input :disabled='isdisabled' v-model="form.Packing_quantity"></el-input>
              </td>
            </tr>
            <tr>
              <td class="tdd">{{ $t('All.量测仪器') }}/{{ $t('All.编号') }}</td>
              <td colspan="7"><el-input :disabled='isdisabled' v-model="form.Measuring_instrument_no"></el-input></td>
              <td class="tdd" colspan="2">{{ $t('All.线位') }}</td>
              <td colspan="6"><el-input :disabled='isdisabled' v-model="form.Line_position"></el-input></td>
            </tr>
          </table>
          <table border="1" style="width:100%;border-bottom: none;" align="center" cellpadding="10" cellspacing="0">
            <tr>
              <td colspan="15"><span style="letter-spacing: 56px;margin-left: 56px;text-align: center;">{{ $t('All.不良品记录')
                  }}</span></td>
              <td colspan="1">
                <el-button style="margin-left: 11px;" size="mini" v-show="Nljlisool" type="primary"
                  @click="Nljlisool = false">{{ $t('All.收起') }}</el-button>
                <el-button style="margin-left: 11px;" size="mini" v-show="!Nljlisool" type="primary"
                  @click="Nljlisool = true">{{ $t('All.展开') }}</el-button>
              </td>
            </tr>
          </table>
          <table v-if="Nljlisool" border="1" style="width:100%;border-bottom: none;table-layout: fixed; word-break: break-all; word-wrap: break-word;" align="center" cellpadding="10"
            cellspacing="0">
            <tr>
              <td colspan="2" class="tdd">{{ $t('All.排序') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.日期') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.异常类型') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.班别') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.工站名称') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.处理方式') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.状态') }}</td>
              <td colspan="1" class="tdd">{{ $t('All.查看') }}</td>
            </tr>
            <tr v-for="(item, index) in buliandata" :key="index">
              <td colspan="2" class="tdd">{{ index + 1 }}</td>
              <td colspan="2" class="tdd">{{ item.Date }}</td>
              <td colspan="2" class="tdd">{{ item.Exceptiontype }}</td>
              <td colspan="2" class="tdd">{{ item.Class }}</td>
              <td colspan="2" class="tdd">{{ item.Processname }}</td>
              <td colspan="2" class="tdd">{{ item.Statestr }}</td>
              <td colspan="2" class="tdd"> {{ item.State == 0 ? $t('All.不良发现') : item.State == 2 ? $t('All.重工中') :
                $t('All.完结')}} </td>
              <td colspan="1"><el-button type="primary"
                  @click="setleipqcexceptiontdatalist(item.Qrcode)">{{ $t('All.查看') }}</el-button></td>
            </tr>
          </table>
          <table border="1" style="width:100%;border-bottom: none;" align="center" cellpadding="10" cellspacing="0">
            <tr>
              <td colspan="15"><span style="letter-spacing: 56px;margin-left: 56px;text-align: center;">{{ $t('All.物料追溯')
                  }}</span></td>
              <td colspan="1">
                <el-button style="margin-left: 11px;" size="mini" v-show="Materialisool" type="primary"
                  @click="Materialisool = false">{{ $t('All.收起') }}</el-button>
                <el-button style="margin-left: 11px;" size="mini" v-show="!Materialisool" type="primary"
                  @click="Materialisool = true">{{ $t('All.展开') }}</el-button>
              </td>
            </tr>
          </table>
          <table v-if="Materialisool" border="1" style="width:100%;border-bottom: none;" align="center" cellpadding="10"
            cellspacing="0">
            <tr>
              <td colspan="2" class="tdd">{{ $t('All.IQC系统单号') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.材料名称') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.供应商') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.进料日期') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.负责人') }}</td>
              <td colspan="2" class="tdd">{{ $t('All.领用数量') }}</td>
              <td colspan="2" class="tdd">LOT NO.</td>
              <td colspan="2" class="tdd">{{ $t('All.QC确认') }}</td>
            </tr>
            <tr v-for="(item, index) in form.Material" :key="item.Id">
              <td colspan="2" class="tdd"><el-input disabled v-model="item.IQCNumbers"></el-input></td>
              <td colspan="2" class="tdd"><el-input disabled v-model="item.Material_name"></el-input></td>
              <td colspan="2" class="tdd"><el-input disabled v-model="item.Supplier"></el-input></td>
              <td colspan="2" class="tdd"><el-input disabled v-model="item.Feeding_date"></el-input></td>
              <td colspan="2" class="tdd"><el-input disabled v-model="item.Person"></el-input></td>
              <td colspan="2" class="tdd"><el-input disabled v-model="item.Quantity"></el-input></td>
              <td colspan="2" class="tdd"><el-input disabled v-model="item.Lot_no"></el-input></td>
              <td v-show="isdisabled" colspan="2" class="tdd"><el-input :disabled='isdisabled'
                  v-model="item.Name"></el-input></td>
              <td v-show="!isdisabled" colspan="2" class="tdd">
                <el-select v-model="item.Name" :disabled="item.State == 1" :placeholder="$t('All.请选择')"
                  @change="Materiala(item, index, $event)">
                  <el-option :label="$t('All.删除')" :value="$t('All.删除')"></el-option>
                </el-select>
              </td>
            </tr>
          </table>
          <table border="1" style="width:100%;border-bottom: none;" align="center" cellpadding="10" cellspacing="0">
            <td colspan="17"><span style="letter-spacing: 56px;margin-left: 56px;text-align: center;">{{ $t('All.巡检记录')
                }}</span></td>
          </table>
          <!---->
          <formtr v-if="isFormReady" :data="form.Patrol_records" :isdisabled="isdisabled" :addDomains="addDomains" :Keyenter="Keyenter"
            :removeDomain="removeDomain" :addlist="addlist" :form="form"></formtr>
          <!---->
          <!---->
          <table border="1" style="width:100%;border-bottom: none;" align="center" cellpadding="10" cellspacing="0">
            <tr>
              <td class="tdd" style="width: 50px;">{{ $t('All.备注') }} </td>
              <td colspan="3" class="tdd" v-show="!isdisabled"><el-input class="tdd"
                  style="word-wrap:break-word;text-align: left;" :rows="3" type="textarea"
                  v-model="form.Beizhu"></el-input></td>
              <td colspan="3" class="tdd" v-show="isdisabled" style="text-align: left;line-height: 17px;"><span
                  v-html="form.Beizhu"></span></td>
            </tr>
            <tr v-for="(item, index) in form.Beilist" :key="index">
              <td class="tdd" style="max-width: 50px;">{{ $t('All.备注') }} {{ index }}</td>
              <td class="tdd" v-show="!isdisabled"><textarea class="el-input__inner"
                  style="display: block;resize: none;border-radius: unset;font-size: 14px;" rows="1"
                  v-model.lazy="item.Title"></textarea></td>
              <td class="tdd" v-show="isdisabled" style="text-align: left;"><span>{{ item.Title.length === 0 ? item.Title +
                item.Txte : item.Title + '：' + item.Txte}}</span></td>
              <td class="tdd" v-show="!isdisabled" style="word-wrap:break-word;text-align: left;"><textarea
                  :disabled='isdisabled' class="el-input__inner"
                  style="display: block;resize: none;border-radius: unset;font-size: 14px;" rows="1"
                  v-model.lazy="item.Txte"></textarea></td>
              <td class="tdd" style="width: 120px;" v-if="!isdisabled">
                <el-button size="mini" type="primary" @click="addbeizhulist(item, index)">Add</el-button>
                <el-button size="mini" type="danger" v-show="form.Beilist.length > 1"
                  @click="removebeizhulist(item, index)">Del</el-button>
              </td>
            </tr>
          </table>
          <table border="1" style="width:100%;" align="center" cellpadding="10" cellspacing="0">
            <tr>
              <td class="tdd" style="width: 50px;">{{ $t('All.备注') }} </td>
              <td class="tdd" style="word-wrap:break-word;text-align: left;">1.{{ this.$t('All.固定备注') }}(5PCS)</td>
            </tr>
          </table>
          <el-row>
            <el-col :span="12" style="border: 0px solid transparent;"><span
                style="font-size: 1.5vw;">{{ this.$t('IQC.核准') }}: {{ form.Auditor }}</span></el-col>
            <el-col :span="12" style="border: 0px solid transparent;"><span
                style="font-size: 1.5vw;">{{ this.$t('IQC.检验员') }}: {{ form.Examination }}</span></el-col>
          </el-row>
          <el-row>
            <el-col :span="12" style="border: 0px solid transparent;">
              <h6></h6>
            </el-col>
            <el-col :span="12" style="border: 0px solid transparent;padding-right: 20px;text-align: right;"><span
                style="font-size: 1.5vw;">NYP1001-47-F</span></el-col>
          </el-row>
        </div>
      <!-- </div> -->
    </div>
    <el-dialog :title="this.$t('system.fjian')" :visible.sync="dialogVisible" width="80%" :before-close="handleClose"
      append-to-body>
      <fqcUpload :fqcadmin="form.Number" :moban="form.Numbers" :isdata="isdisabled"></fqcUpload>
    </el-dialog>
    <transition name="fade-transform" mode="out-in">
      <component :is="TabComponent" :Iscoder="Iscoder" :Getxwuliao="Getxwuliao" :Materialadddata="Materialadddata"
        :Numbers="form.Numbers" :Factory="form.Factory" :gongdan="form.Order_no" :Keyenter="Keyenter"
        :Getipqcexceptiontdatalist="Getipqcexceptiontdatalist" :NewMaterialadddata="NewMaterialadddata" style="z-index: 888;"></component>
    </transition>
    <el-drawer :title="$t('All.异常处理过程')" :visible.sync="dialog" direction="rtl" size="40%" append-to-body>
      <div style="padding: 10px;">
        <el-timeline>
          <el-timeline-item v-for="(item, index) in gridData" :key="index" :timestamp="item.Date" placement="top">
            <el-card>
              <h4>{{ item.Statestr }}</h4>
              <h4 v-if="item.Size">{{ $t('All.尺寸') }}：{{ item.Size }}</h4>
              <span>{{ item.Describe }}</span>
              <p>{{ item.Text }}</p>
              <p>{{ item.Processname }}</p>
              <p>{{ item.Username }}{{ $t('All.提交于') }}{{ item.Date }}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
        <el-form :model="buliangform" v-if="buliangformbool">
          <el-form-item :label="$t('All.确认方式')">
            <el-select v-model="buliangform.Statestr" :placeholder="$t('All.请选择')">
              <el-option :label="$t('All.认可')" :value="$t('All.认可')"></el-option>
              <el-option :label="$t('All.驳回')" :value="$t('All.驳回')"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('All.描述分析')">
            <el-input v-model="buliangform.Describe" type="textarea" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer" v-if="buliangformbool">
          <el-button type="primary" @click="tijiaobuliang()">{{ $t('All.提交') }}</el-button>
          <el-button @click="dialog = false">{{ $t('All.取消') }}</el-button>
        </div>
      </div>
    </el-drawer>
    <el-form style="max-width: 800px;margin: auto;" size="medium" label-width="90px" label-position="top">
      <el-form-item :label="$t('All.签核记录')">
        <el-radio-group style="padding-bottom: 20px;padding-left: 5%;" v-model="reverse">
          <el-radio :label="true">{{ $t('All.倒序') }}</el-radio>
          <el-radio :label="false">{{ $t('All.正序') }}</el-radio>
        </el-radio-group>
        <el-timeline :reverse="reverse">
          <el-timeline-item v-for="(activity, index) in Signlog" :key="index" :timestamp="activity.Date">
            {{ $PublicJs.State(activity.State) }}
            <p>{{ activity.Username }}</p>
            <p>{{ activity.Notes }}</p>
          </el-timeline-item>
        </el-timeline>
      </el-form-item>
    </el-form>
    <IPQCqianhe v-if="qianhe" :Qianhecolse="Qianhecolse" :UserIpqcAdminhek="UserIpqcAdminhek"
      :UserIpqcAdminboh="UserIpqcAdminboh" />
  </div>
</template>
<script>
import fqcUpload from './Upload/IPQCUpload.vue'
import IPQCqianhe from './Upload/IPQCqianhe.vue'
import { mapMutations } from 'vuex'
import formtr from './tdvue.vue'
import Vue from 'vue'
// 自定义指令，实现按下enter后，光标自动跳转下一个输入框
Vue.directive('enterNextInput', {
  inserted: function (el) {
    el.addEventListener('keydown', function (e) {
      e = e || window.event
      const charcode = e.keyCode || e.which
      if (charcode === 13) { // 检测 Enter 键
        try {
          const inputs = Array.from(document.querySelectorAll('input'))
          const currentIndex = inputs.indexOf(document.activeElement)
          if (currentIndex !== -1) {
            const nextIndex = inputs[currentIndex].name === 'Text5' ? currentIndex + 7 : currentIndex + 1
            if (nextIndex < inputs.length) {
              inputs[nextIndex].focus()
            }
          }
        } catch (error) {
          console.error('Error in enterNextInput directive:', error)
        }
      }
    })
  }
})
export default {
  data () {
    return {
      form: {
        Numbers: '',
        Timsdate: '',
        Class: '',
        Order_no: '',
        Customer: '',
        Sopnumber: '',
        Edition: '',
        Xrfnumber: '',
        Icpnumber: '',
        First_article: '',
        Lot_no: '',
        Drawing_no: '',
        Appearance: '',
        Colour: '',
        Color_sample_no: '',
        Test_machine: '',
        Line_position: '',
        Packing_quantity: '',
        Measuring_instrument_no: '',
        Product_name: '',
        Beizhu: '',
        Patrol_records: [
          {
            Numbers: '',
            Index: 0,
            Date1: '',
            Date2: '',
            Patrol: [
              {
                Cid: 0,
                Numbers: '',
                Index: 0,
                Patrol_name: '',
                Specification: '',
                Company: '',
                Value1: '',
                Value2: '',
                Value3: '',
                Value4: '',
                Value5: '',
                Result: '',
                Whether: ''
              }
            ]
          }
        ],
        Beilist: [
          {
            Numbers: '',
            Number: '',
            Index: 0,
            Title: '',
            Txte: ''
          }
        ],
        Examination: '',
        Auditor: '',
        Entered: '',
        Factory: '',
        State: '',
        Material: [{
          Numbers: '',
          Index: 0,
          IQCNumbers: '',
          Quantity: '',
          Material_name: '',
          Supplier: '',
          Feeding_date: '',
          Person: '',
          Lot_no: '',
          Name: '',
          Serialcode: '',
          Item_no: '',
          Type: 0
        }]
      },
      isdisabled: true,
      isqpisboot: false,
      dialogVisible: false,
      TabComponent: '',
      Page: {
        Pageindex: 1,
        PageSize: 1
      },
      TotalCount: 0,
      isjies: false,
      Materialisool: false,
      Nljlisool: false,
      buliandata: [],
      dialog: false,
      gridData: [],
      dialogedit: false,
      buliangform: {
        Statestr: this.$t('All.认可'),
        Describe: ''
      },
      buliangqrcode: '',
      buliangformbool: false,
      qianhe: false,
      Signlog: [],
      reverse: true,
      isFormReady: false
    }
  },
  props: ['Addtab', 'RemoveTab', 'Renewtargename', 'Rendw'],
  created () {
    if (this.$store.state.UserData === null) {
      this.Renewtargename(this.$t('All.待审'), 'Examine', 'UserJyySele')
      this.RemoveTab(this.$t('All.IPQC检验单'))
      this.$message.error(this.$t('All.模版不存在'))
    } else {
      this.form = JSON.parse(JSON.stringify(this.$store.state.UserData))
      this.form.Patrol_records = (Array.isArray(this.form.Patrol_records) ? this.form.Patrol_records : []).map((item, index) => ({
        ...item,
        Isbool: 0
      }))
      // this.GetMaterial(this.form.Order_no)
      this.Getipqcexceptiontdata(this.form.Order_no, this.form.Factory)
      if (this.form.Patrol_records.length === 0) {
        this.form.Patrol_records = [
          {
            Numbers: this.form.Numbers,
            Number: this.form.Number,
            Index: 0,
            Date1: '',
            Date2: '',
            Ispiece: 0,
            Isbool: 1,
            Patrol: [
              {
                Cid: 0,
                Numbers: this.form.Numbers,
                Number: this.form.Number,
                Index: 0,
                Patrol_name: '',
                Specification: '',
                Company: '',
                Value1: '',
                Value2: '',
                Value3: '',
                Value4: '',
                Value5: '',
                Result: '',
                Whether: ''
              }
            ]
          }
        ]
      }
    }
    this.$nextTick(() => {
      this.isFormReady = true
    })
  },
  components: {
    formtr,
    fqcUpload,
    IPQCqianhe,
    IPQCQrcode: () => import('../Ipqc/IPQCQrcode'),
    // 新版扫码，先发料在扫码
    IPQCQrcodes: () => import('../Ipqc/IPQCQrcodes')
  },
  mounted () {
  },
  methods: {
    ...mapMutations(['UserData', 'ConductIs']),
    openScanOld () {
      this.TabComponent = 'IPQCQrcode'
    },
    openScanNew () {
      this.TabComponent = 'IPQCQrcodes'
    },
    handlePrint () {
      const printTrigger = this.$refs.ipqcPrintTrigger
      if (printTrigger && typeof printTrigger.click === 'function') {
        printTrigger.click()
      }
    },
    Qianhecolse () {
      this.qianhe = false
    },
    Iscoder (row) {
      this.TabComponent = row
    },
    handleClose (done) {
      this.$confirm(this.$t('All.确认关闭'), {
        confirmButtonText: this.$t('All.确认'),
        cancelButtonText: this.$t('All.取消'),
        type: 'warning'
      })
        .then(_ => {
          done()
        })
        .catch(_ => { })
    },
    getCurrentTime () {
      // 获取当前时间并打印
      const yy = new Date().getFullYear()
      const mm = new Date().getMonth() + 1
      const dd = new Date().getDate()
      const gettime = yy + this.$t('All.年') + mm + this.$t('All.月') + dd + this.$t('All.日')
      return gettime
    },
    State (row) {
      var state
      switch (row) {
        case 0:
          state = this.$t('login.pending')
          break
        case 1:
          state = this.$t('system.bohui')
          break
        case 2:
          state = this.$t('system.wanjie')
          break
        case 3:
          state = this.$t('system.zancun')
          break
        case 4:
          state = this.$t('system.tuihuo')
          break
        case 5:
          state = this.$t('system.tecai')
          break
        default:
          state = this.$t('All.异常')
          break
      }
      return state
    },
    addbeizhulist (item, index) {
      const contr = {
        Number: item.Number,
        Numbers: '',
        Index: item.Index + 1,
        Title: '',
        Txte: ''
      }
      this.form.Beilist.splice(index + 1, 0, contr)
      for (let i = 0; i < this.form.Beilist.length; i++) {
        this.form.Beilist[i].Index = i
      }
    },
    removebeizhulist (item) {
      this.$confirm(this.$t('All.是否删除此节点'), this.$t('All.提示'), {
        confirmButtonText: this.$t('All.确认'),
        cancelButtonText: this.$t('All.取消'),
        type: 'warning'
      })
        .then(() => {
          var index = this.form.Beilist.indexOf(item)
          if (index !== -1) {
            this.form.Beilist.splice(index, 1)
          }
          for (let i = 0; i < this.form.Beilist.length; i++) {
            this.form.Beilist[i].Index = i
          }
        })
        .catch(() => {
        })
    },
    addDomains (item, index) {
      const contr = {
        Number: item.Number,
        Numbers: item.Numbers,
        Index: item.Index + 1,
        Date1: '',
        Date2: '',
        Ispiece: 0,
        Isbool: 1,
        Patrol: JSON.parse(JSON.stringify(item.Patrol))
      }
      contr.Patrol.forEach(element => {
        element.Cid = contr.Index
        element.Value1 = ''
        element.Value2 = ''
        element.Value3 = ''
        element.Value4 = ''
        element.Value5 = ''
        element.Result = ''
        element.Whether = ''
      })
      this.form.Patrol_records.splice(index + 1, 0, contr)
      for (let i = 0; i < this.form.Patrol_records.length; i++) {
        this.form.Patrol_records[i].Index = i
        this.form.Patrol_records[i].Patrol.forEach(element => {
          element.Cid = this.form.Patrol_records[i].Index
        })
      }
    },
    removeDomain (item) {
      this.$confirm(this.$t('All.是否删除此节点'), this.$t('All.提示'), {
        confirmButtonText: this.$t('All.确认'),
        cancelButtonText: this.$t('All.取消'),
        type: 'warning'
      })
        .then(() => {
          var index = this.form.Patrol_records.indexOf(item)
          if (index !== -1) {
            this.form.Patrol_records.splice(index, 1)
          }
          for (let i = 0; i < this.form.Patrol_records.length; i++) {
            this.form.Patrol_records[i].Index = i
            this.form.Patrol_records[i].Patrol.forEach(element => {
              element.Cid = i
            })
          }
        })
        .catch(() => {
        })
    },
    addlist (indexx, item, index, value) {
      if (value === this.$t('All.增加')) {
        this.addDomainlist(indexx, item, index)
        this.form.Patrol_records[indexx].Patrol[index].Whether = ''
        return
      }
      if (value === this.$t('All.删除')) {
        this.$confirm(this.$t('All.是否删除此节点'), this.$t('All.提示'), {
          confirmButtonText: this.$t('All.确认'),
          cancelButtonText: this.$t('All.取消'),
          type: 'warning'
        })
          .then(() => {
            this.removeDomainlist(item, indexx)
          })
          .catch(() => {
            this.form.Patrol_records[indexx].Patrol[index].Whether = ''
          })
      }
    },
    addDomainlist (indexx, item, index) {
      const contr = {
        Number: item.Number,
        Numbers: item.Numbers,
        Cid: item.Cid,
        Index: 1,
        Patrol_name: item.Patrol_name,
        Specification: item.Specification,
        Company: item.Company,
        Value1: '',
        Value2: '',
        Value3: '',
        Value4: '',
        Value5: '',
        Result: '',
        Whether: ''
      }
      this.form.Patrol_records[indexx].Patrol.splice(index + 1, 0, contr)
      for (let i = 0; i < this.form.Patrol_records[indexx].Patrol.length; i++) {
        this.form.Patrol_records[indexx].Patrol[i].Index = i
      }
    },
    removeDomainlist (item, indexx) {
      var index = this.form.Patrol_records[indexx].Patrol.indexOf(item)
      if (index !== -1) {
        this.form.Patrol_records[indexx].Patrol.splice(index, 1)
      }
      for (let i = 0; i < this.form.Patrol_records[indexx].Patrol.length; i++) {
        this.form.Patrol_records[indexx].Patrol[i].Index = i
      }
    },
    async UserIpqcAdminboh (row) {
      const loadingInstance = this.$loading({ text: this.$t('system.loading'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.8)' })
      try {
        const ipqcformpost = {
          UserData: this.$store.state.Login,
          IpqcUser: this.form,
          Qianheclass: row
        }
        const { data: res } = await this.$http.post('/api/Ipqc/UserIpqcAdminboh', ipqcformpost)
        if (res.status !== 200) {
          loadingInstance.close()
          return this.$message.error(this.$t('All.数据异常'))
        }
        loadingInstance.close()
        this.$message.success(res.msg)
        this.qianhe = false
        this.UserData(null)
        this.Renewtargename(this.$t('All.待审'), 'Examine', 'UserJyySele')
        this.RemoveTab(this.$t('All.IPQC检验单') + '-' + this.form.Numbers)
      } catch (error) {
        this.$message.error(this.$t('All.服务器断开'))
        loadingInstance.close()
      }
    },
    async UserIpqcAdminhek (row) {
      const loadingInstance = this.$loading({ text: this.$t('system.loading'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.8)' })
      try {
        const ipqcformpost = {
          UserData: this.$store.state.Login,
          IpqcUser: this.form,
          Qianheclass: row
        }
        const { data: res } = await this.$http.post('/api/Ipqc/UserIpqcAdminhek', ipqcformpost)
        if (res.status !== 200) {
          loadingInstance.close()
          return this.$message.error(this.$t('All.数据异常'))
        }
        loadingInstance.close()
        this.$message.success(res.msg)
        this.qianhe = false
        this.UserData(null)
        this.Renewtargename(this.$t('All.待审'), 'Examine', 'UserJyySele')
        this.RemoveTab(this.$t('All.IPQC检验单') + '-' + this.form.Numbers)
        this.RemoveTab(this.$t('All.IPQC记录') + '-' + this.form.Numbers)
      } catch (error) {
        this.$message.error(this.$t('All.服务器断开'))
        loadingInstance.close()
      }
    },
    async UserIpqcAdmindel () {
      const loadingInstance = this.$loading({ text: this.$t('system.loading'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.8)' })
      try {
        const { data: res } = await this.$http.post('/api/Ipqc/UserIpqcAdmindel', this.form)
        if (res.status !== 200) {
          loadingInstance.close()
          return this.$message.error(this.$t('All.数据异常'))
        }
        loadingInstance.close()
        this.$message.success(res.msg)
        this.UserData(null)
        this.Renewtargename(this.$t('All.待审'), 'Examine', 'UserJyySele')
        this.RemoveTab(this.$t('All.IPQC检验单') + '-' + this.form.Numbers)
      } catch (error) {
        this.$message.error(this.$t('All.服务器断开'))
        loadingInstance.close()
      }
    },
    handledelipqc (done) {
      this.$confirm(this.$t('All.确认删除'), {
        confirmButtonText: this.$t('All.确认'),
        cancelButtonText: this.$t('All.取消'),
        type: 'warning'
      })
        .then(async_ => {
          this.UserIpqcAdmindel()
        })
        .catch(_ => {})
    },
    async UserDataZanCun () {
      const loadingInstance = this.$loading({ text: this.$t('system.loading'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.8)' })
      try {
        const formdata = { ...this.form }
        formdata.State = 3
        const { data: res } = await this.$http.post('/api/Ipqc/UserIpqcAdminup', formdata)
        if (res.status !== 200) {
          loadingInstance.close()
          return this.$message.error(this.$t('All.数据异常'))
        }
        loadingInstance.close()
        this.$message.success(res.msg)
        this.UserData(null)
        this.Renewtargename(this.$t('All.待审'), 'Examine', 'UserJyySele')
        this.RemoveTab(this.$t('All.IPQC检验单') + '-' + this.form.Numbers)
      } catch (error) {
        this.$message.error(this.$t('All.服务器断开'))
        loadingInstance.close()
      }
    },
    async songceng () {
      const loadingInstance = this.$loading({ text: this.$t('system.loading'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.8)' })
      try {
        const formdata = { ...this.form }
        formdata.State = 0
        const { data: res } = await this.$http.post('/api/Ipqc/UserIpqcAdminup', formdata)
        if (res.status !== 200) {
          loadingInstance.close()
          return this.$message.error(this.$t('All.数据异常'))
        }
        loadingInstance.close()
        this.$message.success(res.msg)
        this.UserData(null)
        this.Renewtargename(this.$t('All.待审'), 'Examine', 'UserJyySele')
        this.RemoveTab(this.$t('All.IPQC检验单') + '-' + this.form.Numbers)
      } catch (error) {
        this.$message.error(this.$t('All.服务器断开'))
        loadingInstance.close()
      }
    },
    Materiala (item, index, value) {
      if (value === this.$t('All.增加')) {
        this.Materialaddlist(item, index)
        this.Material[index].Name = ''
        return
      }
      if (value === this.$t('All.删除')) {
        this.$confirm(this.$t('All.是否删除此节点'), this.$t('All.提示'), {
          confirmButtonText: this.$t('All.确认'),
          cancelButtonText: this.$t('All.取消'),
          type: 'warning'
        })
          .then(() => {
            if (this.form.Factory === 'TC') {
              this.newremoveMaterial(item)
            } else {
              this.removeMaterial(item)
            }
          })
          .catch(() => {
            this.Material[index].Name = ''
          })
      }
    },
    Materialaddlist (item, index) {
      const contr = {
        Numbers: item.Numbers,
        Index: item.Index + 1,
        Quantity: '',
        IQCNumbers: '',
        Material_name: '',
        Supplier: '',
        Feeding_date: '',
        Person: '',
        Lot_no: '',
        Name: '',
        Serialcode: ''
      }
      this.Material.splice(index + 1, 0, contr)
      for (let i = 0; i < this.Material.length; i++) {
        this.Material[i].Index = i
      }
    },
    async removeMaterial (item) {
      const { data: res } = await this.$http.post('/api/Semifinished/DelMaterial', item)
      if (res.status !== 200) return this.$message.error(res.msg)
      this.$message.success(res.msg)
      this.GetMaterial(this.form.Order_no)
    },
    async newremoveMaterial (item) {
      const { data: res } = await this.$http.post('/api/MaterialLabel/DelMaterial', item)
      if (res.status !== 200) return this.$message.error(res.msg)
      this.$message.success(res.msg)
      this.GetMaterial(this.form.Order_no)
    },
    Getxwuliao (row) {
      for (let j = 0; j < this.Material.length; j++) {
        if (this.Material[j].Serialcode === row) {
          this.$message.error(this.$t('All.此PASS数据已被采集'), this.$t('All.请勿重复扫描'))
          return true
        }
      }
      return false
    },
    Materialadddata (row) {
      for (let j = 0; j < this.Material.length; j++) {
        if (this.Material[j].Serialcode === row.Serialcode) {
          this.$message.error(this.$t('All.此PASS数据已被采集'), this.$t('All.请勿重复扫描'))
          return
        }
      }
      // 发起异步请求
      this.$http.post('/api/Semifinished/AddMaterial', row)
        .then((response) => {
          // 检查HTTP响应状态码
          if (response.status === 200) {
            const res = response.data

            // 处理服务器端返回的数据
            if (res.status === 200) {
              this.GetMaterial(this.form.Order_no)
              this.$message.success(this.$t('All.采集成功'))
            } else {
              this.$message.error(res.msg)
            }
          } else {
            this.$message.error(this.$t('All.HTTP请求失败'))
          }
        })
        .catch((error) => {
          console.error(error)
          this.$message.error(this.$t('All.操作失败'))
        })
    },
    async NewMaterialadddata (serialCode, orderNo, type) {
      const { data: res } = await this.$http.post(`/api/MaterialLabel/AddMaterial?serialCode=${serialCode}&orderNo=${orderNo}&type=${type}`)
      if (res.status !== 200) return this.$message.error(res.msg)
      this.$message.success(res.msg)
      this.GetMaterial(this.form.Order_no)
    },
    async GetMaterial (row) {
      const { data: res } = await this.$http.get(`/api/Semifinished/GetMaterial?gongdan=${row}`)
      if (res.status !== 200) return this.$message.error(res.msg)
      this.Material = res.response
    },
    async Getipqcexceptiontdata (row, row1) {
      const { data: res } = await this.$http.get(`/api/IPQC/Getipqcexceptiontdata?gongdan=${row}&chagnqu=${this.form.Factory}`)
      if (res.status !== 200) return this.$message.error(res.msg)
      this.buliandata = res.response
    },
    async Getipqcexceptiontdatalist (row, row1) {
      this.buliangqrcode = row
      const { data: res } = await this.$http.get(`/api/IPQC/Getipqcexceptiontdatalist?qrcode=${row}&chagnqu=${this.form.Factory}`)
      if (res.status !== 200) return this.$message.error(res.msg)
      this.gridData = res.response
      this.dialog = true
      this.buliangformbool = true
      this.TabComponent = ''
    },
    async tijiaobuliang () {
      const data = {
        qrcode: this.buliangqrcode,
        Statestr: this.buliangform.Statestr,
        Describe: this.buliangform.Describe,
        Text: '',
        Type: this.buliangform.Statestr === this.$t('All.认可') ? 2 : 1,
        Mac: this.$t('All.IPQC设备'),
        Processname: this.$t('All.品管部门IPQC设备'),
        User: this.$store.state.Login.User,
        Username: this.$store.state.Login.Username,
        Factory: this.form.Factory
      }
      const { data: res } = await this.$http.post('/api/IPQC/Addipqcexceptiontdatalist', data)
      if (res.status !== 200) return this.$message.error(res.msg)
      this.$message.success(res.msg)
      this.dialog = false
      this.buliangformbool = false
      this.Getipqcexceptiontdata(this.form.Order_no, this.form.Factory)
    },
    async setleipqcexceptiontdatalist (row) {
      this.buliangqrcode = row
      const { data: res } = await this.$http.get(`/api/IPQC/Getipqcexceptiontdatalist?qrcode=${row}&chagnqu=${this.form.Factory}`)
      if (res.status !== 200) return this.$message.error(res.msg)
      this.gridData = res.response
      this.dialog = true
      this.buliangformbool = false
    },
    async FQCSignloglist (row) {
      try {
        const { data: res } = await this.$http.post('/api/FQC/FQCSignloglist?Numbers=' + row)
        if (res.status !== 200) return
        this.Signlog = res.response
      } catch (error) {
        alert(error)
      }
    },
    // 生成指定区间的随机数
    generateRandomValue: function (min, max) {
      const randomValue = (Math.random() * (max - min) + min).toFixed(2) // 保留两位小数
      return isNaN(randomValue) ? '[表情]' : randomValue // 若生成的数值为 NaN，则返回 "[表情]"
    },

    // 解析区间并更新 Value1 - Value5
    updateValues: function () {
      this.form.Patrol_records.forEach(pa => {
        pa.Numbers = this.form.Numbers
        pa.Patrol.forEach(record => {
          record.Result = 'Pass'
          record.Numbers = this.form.Numbers
          if (this.form.Factory === 'VN') {
            record.Whether = 'Đúng/Là'
          } else {
            record.Whether = '是'
          }
          const spec = record.Specification.trim()
          // 检查区间的格式
          let min, max

          // 正则表达式：匹配 "数字±数字"
          const match = spec.match(/(\d+(\.\d+)?)\s*±\s*(\d+(\.\d+)?)/) // 匹配 "数字±数字" 格式
          // 正则表达式：匹配 "数字+-数字" 格式
          const match2 = spec.match(/(\d+(\.\d+)?)\s*\+-\s*(\d+(\.\d+)?)/) // 匹配 "数字+-数字" 格式

          // 处理 380+/-30 这种格式
          const matchPlusMinus = spec.match(/(\d+(\.\d+)?\+\/-\d+(\.\d+)?)/)
          // 提取规格中的数值部分，例如从 "3×0.7±0.2" 中提取 "3×0.7±0.2"
          const matchmultiply = spec.match(/(\d+(\.\d+)?)\s*×\s*(\d+(\.\d+)?)/) // 匹配 "数字×数字" 格式
          // 正则表达式提取 "a + b / -c" 格式的数值
          const match3 = spec.match(/(\d+(\.\d+)?)\+(\d+(\.\d+)?)\/-(\d+(\.\d+)?)/) // 匹配 "数字+数字/-数字" 格式
          // 正则表达式：匹配 "：" 后面的 "数字~数字" 格式，如 "90~100"
          const match4 = spec.match(/(\d+(\.\d+)?)\s*~\s*(\d+(\.\d+)?)/) // 匹配 "数字~数字"
          // 处理类似 "数字-数字 "格式
          const match5 = spec.match(/(\d+(\.\d+)?)\s*-\s*(\d+(\.\d+)?)/)
          // 1. 处理类似 "2000+30/-0" 或 "2000±30" 格式
          if (match) {
            const base = parseFloat(match[1])
            const range = parseFloat(match[3])
            min = base - range
            max = base + range
          } else if (match2) { // "数字+-数字" 格式
            const base = parseFloat(match2[1])
            const range = parseFloat(match2[3])
            min = base - range
            max = base + range
          } else if (matchPlusMinus) { // "数字+/-数字" 格式
            const [base, range] = matchPlusMinus[0].split('+/-').map(Number)
            min = base - range
            max = base + range
          } else if (matchmultiply) { // "3×0.7±0.2"
            // 计算基础值 3 * 0.7
            const base = parseFloat(matchmultiply[1]) * parseFloat(matchmultiply[3])
            // 提取范围部分
            const rangeMatch = spec.match(/±\s*(\d+(\.\d+)?)/)
            if (rangeMatch) {
              const range = parseFloat(rangeMatch[1])
              // 计算最小值和最大值
              min = base - range
              max = base + range
            }
          } else if (match3) { // "数字+数字/-数字" 格式
            const base = parseFloat(match3[1]) // 提取基准值（a）
            const add = parseFloat(match3[3]) // 提取加值（b）
            const subtract = parseFloat(match3[5]) // 提取减值（c）
            // 计算最小值和最大值
            min = base - subtract
            max = base + add
          } else if (match4) { // 处理类似 "30 ~ 40" 格式
            min = parseFloat(match4[1].trim())
            max = parseFloat(match4[3].trim())
          } else if (match5) { // 处理类似 "adc:10-20" 格式
            min = parseFloat(match5[1].trim())
            max = parseFloat(match5[3].trim())
          } else if (/pcs/.test(spec) || /PCS/.test(spec)) {
            const match = spec.match(/(\d+)/) // 提取数字部分
            if (match) {
              const number = parseFloat(match[1])
              record.Value1 = number.toString()
              record.Value2 = number.toString()
              record.Value3 = number.toString()
              record.Value4 = number.toString()
              record.Value5 = number.toString()
              return // 处理完 pcs 格式后直接返回，不再继续处理
            }
          }

          // 如果确定了数值范围，则生成随机值
          if (min !== undefined && max !== undefined) {
            record.Value1 = this.generateRandomValue(min, max)
            record.Value2 = this.generateRandomValue(min, max)
            record.Value3 = this.generateRandomValue(min, max)
            record.Value4 = this.generateRandomValue(min, max)
            record.Value5 = this.generateRandomValue(min, max)
          } else {
            // 如果没有有效的数字区间（例如纯字符），则将 Value1-V5 留空或根据需求设定
            record.Value1 = '√'
            record.Value2 = '√'
            record.Value3 = '√'
            record.Value4 = '√'
            record.Value5 = '√'
          }
        })
      })
    },
    fileopen (url) {
      this.ConductIs('')
      this.$store.state.Url = ''
      this.$nextTick(() => { // 异步关闭
        setTimeout(() => {
          // 在延迟2秒后执行的代码
          this.$store.state.Url = this.$Upload + '/' + url
          this.ConductIs('ConductIs')
        }, 500)
      })
    },
    Keyenter (indexx, item, index) {
      this.form.Patrol_records[indexx].Patrol[index].Result = ''
      const valany = []
      if (item.Value1 !== null && item.Value1 !== '' && item.Value1 !== undefined) {
        valany.push(parseFloat(item.Value1))
      }
      if (item.Value2 !== null && item.Value2 !== '' && item.Value2 !== undefined) {
        valany.push(parseFloat(item.Value2))
      }
      if (item.Value3 !== null && item.Value3 !== '' && item.Value3 !== undefined) {
        valany.push(parseFloat(item.Value3))
      }
      if (item.Value4 !== null && item.Value4 !== '' && item.Value4 !== undefined) {
        valany.push(parseFloat(item.Text4))
      }
      if (item.Value5 !== null && item.Value5 !== '' && item.Value5 !== undefined) {
        valany.push(parseFloat(item.Value5))
      }
      var numericValues = valany.filter(value => typeof value === 'number' && !isNaN(value))
      var Max = Math.max.apply(Math, numericValues)
      var Min = Math.min.apply(Math, numericValues)
      var dataine = this.$PublicJs.Calculation(item.Specification, Max, Min)
      this.form.Patrol_records[indexx].Patrol[index].Result = dataine
      this.form.Patrol_records[indexx].Patrol[index].Whether = '是'
      // console.log('最大值：' + Max + ' 最小值：' + Min + ' 计算结果：' + dataine)
    }
  }
}
</script>
<style lang="less" scoped>
.wbobye {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: rgba(255, 255, 255);
  min-width: 903px;
}

.el-col {
  border: 1px solid;
  margin-right: -1px;
  margin-bottom: -1px;
  line-height: 4.5vw;
  font-size: 2vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.grid-content {
  min-height: 36px;
}

.row-bg {
  background-color: #f9fafc;
}
</style>
